<template>

  <div class="folder-list" >

    <div class="folder-list__left-side left-side">
      <div class="left-side__icon">
        <i class="el-icon-folder"></i>
      </div>
      <div class="left-side__count text-block">
        <div class="text-block__title">{{ folder.amount_title }}</div>
        <div class="text-block__subtitle">{{ folder.amount }}</div>
      </div>
    </div>
    <div style="flex: 1;"></div>
    <div class="folder-list__right-side right-side">
      <div class="right-side__date">

        <div class="left-side__count text-block">
          <div class="text-block__title">{{ folder.download_at_title }}</div>
          <div class="text-block__subtitle"> {{ $root.dateDefault(folder.download_at) }}</div>
        </div>
      </div>
      <div class="right-side__icon">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "FolderListItem",
  data() {
    return {}
  },
  components: {},
  props: {
    folder: {}
  },
  watch: {},
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
.folder-list {
  margin: 12px 0;
  padding: 0 23px;
  height: 60px;

  background: #fff;
  border-radius: 6px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  transition: all ease .2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16),
    0 4px 8px rgba(55, 71, 79, 0.08);
  }

}

.left-side {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
  color: #111;

    width: 26px;
    font-size: 26px;
  }

  &__count {
    margin-left: 23px;
  }
}

.right-side {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
    transition: all ease .2s;

    margin-left: 90px;
    width: 26px;
    font-size: 26px;
  }


}


.text-block {
  font-size: 13px;
  line-height: 16px;

  &__title {
    color: #8E8E93;
  }

  &__subtitle {
    color: #111;
    padding: 2px 0;
  }
}

</style>
